<template>
    <div class="somaticTree">
        <div class="somaticTree-container" :style="'height:' + clientH +'px; padding-top: 5px'">
        <slot name="btn" />

        <div class="somaticTree_body">
            <h1>Показатели психических функций</h1>
            <div class="body_age">
                <div class="age-top">
                    <p ref="ageTxt" class="age-txt">Возраст </p>
                    <!-- <div class="nav-wrap">
                        <div class="nav-container">
                            <div 
                                :style="{'width': width + 'px'}" 
                                class="nav-line"
                                :class="{'maleLine':!sex, 'femaleLine':sex}"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="62" viewBox="0 0 33 62" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0135 27.31C25.7235 29.6 17.6935 35.8115 17.6935 43.0015V46.0042C17.6935 49.0541 20.2335 51.06 20.9335 51.76C22.0235 52.84 22.6935 54.34 22.6935 56C22.6935 59.31 20.0135 62 16.6935 62C13.3735 62 10.6935 59.31 10.6935 56C10.6935 54.34 11.3635 52.84 12.4435 51.76C13.1535 51.06 15.6935 49.0541 15.6935 46.0042C15.6935 42.9542 15.6935 43.0015 15.6935 43.0015C15.6935 35.8115 7.66348 29.6 5.37348 27.31C2.48348 24.42 0.693481 20.42 0.693481 16C0.693481 7.16 7.84348 0.01 16.6935 0C25.5435 0.01 32.6935 7.16 32.6935 16C32.6935 20.42 30.9035 24.42 28.0135 27.31Z"/>
                                </svg>
                            </div>
                            <div class="nav-lineGrey"></div>
                        </div>
                        <div class="nav_number-container">
                            <div class="nav_number" :class="{ 'maleLine': !sex, 'femaleLine': sex }" v-for="(item, idx) in count" :key="idx" @click.prevent="setActive($event, idx)">
                                {{ idx + 1 }}
                            </div>
                        </div>
                    </div> -->
                    <v-slider
                        class="slider-thumbs-custom"
                        :class="{ 'female': sex, 'male': !sex }"
                        :min="1"
                        :max="count"
                        v-model="ageOnMonth"
                        :tick-labels="tickLabelsSlider"
                        step="1"
                        thumb-label="always"
                        :thumb-size="34"
                        :color="sex ? '#E882DD' : '#717BF9'"
                        :track-color="sex ? '#E882DD' : '#717BF9'"
                    >
                        <template v-slot:thumb-label></template>
                    </v-slider>

                    <div class="age-wrap">
                        <div class="age_switch-container">
                            <p :class="{'male':!sex}">M</p>
                            <v-switch 
                                v-model="sex"
                                color="#E882DD"
                            >
                            </v-switch>
                            <p :class="{'female':sex}">Ж</p>
                        </div>
                        
                        <div class="age_switch-container">
                            <p :class="{'male': !switchBeforeOrAfterOne && !sex, 'female': !switchBeforeOrAfterOne && sex}">До года</p>
                            <v-switch
                                class="switch-custom"
                                v-model="switchBeforeOrAfterOne"
                                @change="changeAge"
                                :color="sex ? '#E882DD' : '#717BF9'"
                                :class="{ 'female': sex, 'male': !sex }"
                            >
                            </v-switch>
                            <p :class="{'male': switchBeforeOrAfterOne && !sex, 'female': switchBeforeOrAfterOne && sex}">После 1 года</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-info">
                <div class="body-text" :style="'height:' + (clientH-334) +'px'">
                    <v-card flat :key="items && items[0] ? items[0].name : 1">
                        <v-card-text class="py-0 my-0">    
                            <v-row>
                                <v-col cols="12" md="8">
                                    <div v-for="(selection, i) in filterProperties(items, switchBeforeOrAfterOne ? ageOnMonth*12*30 : ageOnMonth*30)" :key="'A'+i">
                                        <h2>{{ i }}</h2>
                                        <ul>
                                            <li v-for="(item, key) in selection" :key="'B'+key">
                                                <span class="text-item">
                                                    {{ item.name }}, {{ item.value }}
                                                </span>
                                            </li>
                                        </ul>                                            
                                    </div>                                        
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>
                <div class="body-img">
                    <v-card-text class="py-0 my-0 text-center">
                        <humanImage
                            :ageOnMonth="ageOnMonth"
                            :gender="sex"
                            :activeName="activeName"
                            :switchBeforeOrAfterOne="!switchBeforeOrAfterOne"
                            :dialogSomaticName="dialogSomaticName"
                            :heightOffset="386"
                        />
                    </v-card-text>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
import './index.scss'
import humanImage from "../../Student/HumanImage.vue";
export default {
    components: { humanImage },
    name: 'MentalFunctions',
    props: {
        treeListM: { type: Array, default: () => [] },
        treeListJ: { type: Array, default: () => [] }
    },
    data() {
        return {
            tickLabelsSlider: [1,2,3,4,5,6,7,8,9,10,11,12],
            count: 12,
            switchBeforeOrAfterOne: false,
            dialogSomaticName: null,
            ageOnMonth: 1,
            clientH: 688,
            selectedItem: null,
            clickShow: true,
            sex: false,
            width: 0,
            items: [],
            activeName: 'Система психических функций',
            tapLevel1index: null,
        }
    },
    watch: {
        sex(val) {
            if(val) {
                this.items = this.treeListJ
            }
            if(!val) {
                this.items = this.treeListM
            }
        }
    },
    methods: {
        setActive(ev,i) {
            const w = ev.target.getBoundingClientRect().left - (this.$refs.ageTxt.getBoundingClientRect().right + 20)
            this.width = w
            this.ageOnMonth = i+1
        },
        filterProperties(array, ageOnDay) {
            if(array.length > 0) {
                let res = [];
    
                for (let i = 0; i < array.length; i++) {
                    for (let j = 0; j < array[i].properties.length; j++) {
    
                        let left = 0, right = array[i].properties[j].ageValues.length - 1;
                    
                        while(left <= right) {
                            let middle = Math.floor((left+right) / 2), currentIteration = array[i].properties[j].ageValues[middle];
    
                            if (currentIteration.ageOnDay < ageOnDay) {
                                left = middle + 1;
                            } else if (currentIteration.ageOnDay > ageOnDay) {
                                right = middle - 1;
                            } else {
                                left = middle
                                break;
                            }
                        }
    
                        if(array[i].properties[j].ageValues[left] && array[i].properties[j].ageValues[left].ageOnDay == ageOnDay) {
                            res.push({
                                groupName: array[i].name,
                                name: array[i].properties[j].name,
                                value: this.returnResult(array[i].properties[j].ageValues[left])
                            })
                        } else if(array[i].properties[j].ageValues[left-1] && array[i].properties[j].ageValues[left-1].ageOnDay < ageOnDay) {
                            res.push({
                                groupName: array[i].name,
                                name: array[i].properties[j].name,
                                value: this.returnResult(array[i].properties[j].ageValues[left-1])
                            })
                        }
                    }
                }
    
                return res.reduce((group, product) => {
                    const { groupName } = product;
                    group[groupName] = group[groupName] ?? [];
                    group[groupName].push(product);
    
                    return group;
                }, {})
            }

            return {'Данных нет': []}
        },
        returnResult(obj) {
            let res = '';

            if(obj.valueType == 0) {
                if(obj.valueTo) {
                    res = `${obj.measurementName ? obj.measurementName+': ' : ''}${obj.valueFrom}-${obj.valueTo}`
                } else {
                    res = `${obj.measurementName ? obj.measurementName+': От ' : ''}${obj.valueFrom}`
                }
            } else if(obj.valueType == 1) {
                res = obj.valueText
            }

            return res
        },
        changeAge(flag) {
            this.ageOnMonth = 1;
            if(!flag) {
                this.count = 12
                this.tickLabelsSlider = [1,2,3,4,5,6,7,8,9,10,11,12]

                return;
            }
            
            this.count = 18
            this.tickLabelsSlider = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]
        }
    },
    created() {
        this.items = this.treeListM
        this.clientH = window.innerHeight;
    }
}
</script>

